import React from 'react';

interface BootstrapAvatarProps {
    name: string;
    size?: number | string;
    color?: string;
    className?: string;
    round?: boolean;
}

const BootstrapAvatar: React.FC<BootstrapAvatarProps> = ({
                                                             name,
                                                             size = 40,
                                                             color = '#707089',
                                                             className = '',
                                                             round = false,
                                                         }) => {
    const initials = name
        .split(' ')
        .map((n) => n[0])
        .join('')
        .slice(0, 2)
        .toUpperCase();

    return (
        <div
            className={`d-inline-flex align-items-center justify-content-center text-white fw-bold me-1 ${
                round ? 'rounded-circle' : 'rounded'
            } ${className}`}
            style={{
                width: typeof size === 'number' ? `${size}px` : size,
                height: typeof size === 'number' ? `${size}px` : size,
                backgroundColor: color,
                userSelect: 'none',
            }}
        >
            {initials}
        </div>
    );
};

export default BootstrapAvatar;
